import { render } from "./tron-box.vue?vue&type=template&id=912045a4&scoped=true"
import script from "./tron-box.vue?vue&type=script&lang=js"
export * from "./tron-box.vue?vue&type=script&lang=js"

import "./tron-box.vue?vue&type=style&index=0&id=912045a4&scoped=true&lang=scss"

import exportComponent from "/home/runner/work/tronbox/tronbox/spa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-912045a4"]])

export default __exports__